<template>
    <div class="use-biz-pre-paid-card" v-if="showUseBizPrePaidCard">
        <div class="form-group-input-vc biz-pre-paid-card">
            <label class="row-lb font500">{{$t('tour.biz_pre_paid_card')}}</label>
            <div class="row-cnt" :class="{ 'disableOpacity': utils.isReadOnly()}">
                <div class="lst-type">
                    <ul class="row no-gutters">
                        <li v-for="t in bizPrePaidCardSelector" :key="t.id" :value="t.id" class="col" v-on:click="setBizPrePaidCard(t)">
                            <div class="type-txt" :class="{ 'active': (selectBizPrePaidCardoggle.id == t.id) }">{{ t.name }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
import Utils from "@/helpers/utils";
export default {
    name: "bizPrePaidCard",
    components:{

    },
    props: {
        selectedBizPrePaidCard: {
            type: { id: Number, name:String } | null ,
            required: false
        },
        showUseBizPrePaidCard: { type:Boolean }
    },
    data () {
        return {
            bizPrePaidCardSelector: Constants.bizPrePaidCard,
            utils: Utils,
        }
    },
    computed: {
        selectBizPrePaidCardoggle: function () {
            return this.selectedBizPrePaidCard;
        },
    },
    methods: {
        setBizPrePaidCard(select){
            this.$emit('updateBizPrePaidCard', select);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/components/sp/Voucher/BizPrePaidCard.vue